import React from 'react';
import PermButton from '../../core/utils/PermButton';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusCircle, Upload, ChevronUp, Table, Grid, Filter } from 'react-feather';
import { ImageWithBasePath } from 'Core/components';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions } from 'Core/redux/main/slice';
import {
  actions as vendorActions,
  downloadVendorsWithFilters,
} from './store/slice';
import { selectTileView, selectVendorFilterVisible } from './store/selectors';
import { isHeaderVisible } from 'Core/redux/main/selectors';

const { setToogleHeader } = mainActions;
const { toggleTileView, toggleFilterVisible } = vendorActions;

const VendorTopHead = ({ onShowAddModal }) => {
  const dispatch = useDispatch();
  const data = useSelector(isHeaderVisible);
  const tileView = useSelector(selectTileView);
  const filterVisible = useSelector(selectVendorFilterVisible);

  const renderExcelTooltip = props => <Tooltip {...props}>Excel</Tooltip>;
  const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
  const renderTileViewTooltip = props => (
    <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
  );
  const renderFilterTooltip = props => (
    <Tooltip {...props}>{filterVisible ? 'Hide Filters' : 'Show Filters'}</Tooltip>
  );

  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              className="collapsebtn me-2"
              onClick={() => dispatch(setToogleHeader(!data))}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderFilterTooltip}>
            <Link
              to="#"
              className="collapsebtn me-2"
              onClick={() => dispatch(toggleFilterVisible())}
            >
              <Filter />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              to="#"
              className="collapsebtn"
              onClick={() => dispatch(toggleTileView())}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
      <div className="d-flex align-items-center justify-content-sm-end purchase-pg-btn">
        <div className="page-btn">
          <PermButton perm="MASTERS.VENDOR.CREATE">
            <Link
              to="#"
              className="btn btn-added color"
              onClick={onShowAddModal}
            >
              <PlusCircle className="me-2" />
              Add New Vendor
            </Link>
          </PermButton>
        </div>
      </div>
    </>
  );
};

export default VendorTopHead; 